const NotFound = () => {
  return <h1>{"Whoops!.. Page Not Found [404]"}</h1>;
};

export default NotFound;
